import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  // interval;

  constructor(private toastr: ToastrService) { }
  snackbarFun(text, bool, title?, options = {}) {
    // if (this.interval) {
    //   clearInterval(this.interval);
    // }

    // var body = document.getElementsByTagName("body")[0];
    // var snackbar = document.getElementById('snackbar');
    // if (!snackbar) {
    //   snackbar = document.createElement('div');
    //   snackbar.setAttribute('id', 'snackbar');
    // } else {
    //   body.removeChild(snackbar);
    // }
    // snackbar.innerHTML = text;
    // if (bool) {
    //   snackbar.classList.add('show', 'success')
    //   snackbar.style.backgroundColor = 'green';
    // }
    // else {
    //   snackbar.classList.add('show', 'faild');
    //   snackbar.style.backgroundColor = 'red';
    // }
    // // snackbar.className='show';
    // body.appendChild(snackbar);
    // this.interval = setInterval(() => {
    //   snackbar = document.getElementById('snackbar');
    //   if(snackbar != null )
    //   {
    //     body.removeChild(snackbar);
    //   }else{
    //     clearInterval(this.interval);
    //   }
    //  }, 6000);
    options = options ? options : {
      timeOut: 10000,
      positionClass: 'toast-bottom-right', closeButton: true, toastClass: 'toaster-bar', tapToDismiss: true, messageClass: 'toaster-message', progressBar: true
    }

    if (bool) {
      this.toastr.success(text, title || '', options);

    } else {
      this.toastr.error(text, title || '', options);
    }
  }


  ngOnDestroy() {
    // clearInterval(this.interval);
  }
}

// export const DefaultNoComponentGlobalConfig: GlobalConfig = {
//   maxOpened: 0,
//   autoDismiss: false,
//   newestOnTop: true,
//   preventDuplicates: false,
//   resetTimeoutOnDuplicate: false,
//   iconClasses: {
//     error: 'toast-error',
//     info: 'toast-info',
//     success: 'toast-success',
//     warning: 'toast-warning',
//   },

//   // Individual
//   closeButton: false,
//   disableTimeOut: false,
//   timeOut: 5000,
//   extendedTimeOut: 1000,
//   enableHtml: false,
//   progressBar: false,
//   toastClass: 'toast',
//   positionClass: 'toast-top-right',
//   titleClass: 'toast-title',
//   messageClass: 'toast-message',
//   easing: 'ease-in',
//   easeTime: 300,
//   tapToDismiss: true,
//   onActivateTick: false,
//   progressAnimation: 'decreasing',
// };
